import url from 'url'
import querystring from 'querystring'

const ip = /^\d{1,3}(\.\d{1,3}){3}$/g

// URL 环境变量
const query = url.parse(window.location.toString(), true).query

const queryParams = querystring.parse(window.location.search.slice(1))
export const isBindWechat = queryParams.isBindWechat
export const userId = queryParams.userId

// env
window.env = query.env ? query.env.replace('/', '') : undefined
if (window.location.hostname === 'localhost') {
  window.env = 'test'
} else if (window.location.hostname.match(ip)) {
  window.env = 'test'
} else if (window.location.pathname.indexOf('demo') !== -1) {
  window.env = 'test'
} else {
  window.env = 'production'
}

function clearCookies () {
  const c = document.cookie.split('; ')
  for (let i in c) { document.cookie = /^[^=]+/.exec(c[i])[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT' }
}

const noCache = query.nocache
if (noCache) {
  clearCookies()
  window.localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/env.js